<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="using-fb">
          <div class="hr-p" />
          <div class="text-us">
            <h3 class="text-center login-using-fb">Or login with</h3>
          </div>
          <div class="hr-p" />
        </div>
      </div>
      <div class="col-md-8 m-auto">
        <button
          type="button"
          class="btn btn-login-facebook btn-block mt-3 mb-4"
          @click="processFacebookLogin"
        >
          <p class="d-inline align-middle">Facebook</p>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import useAppRouter from '../../composables/useAppRouter'

export default {
  props: ['facebook', 'returnUrl', 'inFrame', 'actionType', 'demo', 'disableRedirect'],
  data() {
    return {
      accesTokenFacebook: '',
      provider: 'facebook',
      stateParam: ''
    }
  },
  computed: {
    getActionType: {
      get: function () {
        return this.actionType
      }
    }
  },
  mounted() {
    this.stateParam = btoa(window.location.origin)
  },
  methods: {
    async postLogonProvider() {
      return axios.post(
        '/account/logon-provider',
        {
          ReturnUrl: '/',
          InFrame: this.inFrame,
          Provider: this.provider,
          Data: this.accesTokenFacebook
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    },

    emitEvent(eventName, params) {
      var vm = this
      vm.$emit(eventName, params)
    },

    async submitFaceBookAccount() {
      var vm = this

      try {
        var res = await vm.postLogonProvider()
        if (res !== undefined && res.status === 200) {
          if (res.data === 'new-connect')
            useAppRouter().show('fb-connect', { accessToken: vm.accesTokenFacebook })
          else vm.redirectToPage()
          this.emitEvent('loggedIn')
        }
      } catch (err) {
        console.log('Error connecting to facebook. ' + err)
      }
    },

    openFbDialog() {
      window.open('https://www.facebook.com/dialog/oauth?client_id=', '', 'toolbar=no')
    },

    processFacebookLogin() {
      var vm = this
      vm.openFacebookLoginDialog(vm.stateParam, vm.facebook.redirectUrl)
    },

    redirectToPage: function () {
      if (this.disableRedirect) return

      if (this.returnUrl) window.location.replace(this.returnUrl)
    },

    openFacebookLoginDialog(stateGuid, redirectOauthUrl) {
      var vm = this
      var popUpHeight = 400
      var popUpwidth = 600
      var screenLeft = 0,
        screenTop = 0
      var windowWidth = 0,
        windowHeight = 0
      var centerLeft = 0,
        centerTop = 0

      if (typeof window.screenLeft !== 'undefined') {
        screenLeft = window.screenLeft
        screenTop = window.screenTop
      } else if (typeof window.screenX !== 'undefined') {
        screenLeft = window.screenX
        screenTop = window.screenY
      }

      windowWidth = window.screen.width
      windowHeight = window.screen.height

      if (window.navigator.userAgent.indexOf('MSIE') > -1) {
        centerLeft = screenLeft - windowWidth / 2
        centerTop = screenTop - windowHeight / 2
      } else if (window.navigator.userAgent.indexOf('Edge') > -1) {
        centerLeft = screenLeft - windowWidth
        centerTop = screenTop - windowHeight
      } else {
        centerLeft = screenLeft + windowWidth / 2 - popUpwidth / 2
        screenTop + windowHeight / 2
        centerTop = window.screen.height / 2 - popUpHeight / 2
      }

      window.open(
        'https://www.facebook.com/dialog/oauth?client_id=' +
          this.facebook.appId +
          '&redirect_uri=' +
          encodeURIComponent(redirectOauthUrl) +
          '&auth_type=rerequest' +
          '&scope=email' +
          '&state=' +
          stateGuid,

        '',
        'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' +
          popUpwidth +
          ',height=' +
          popUpHeight +
          ', top=' +
          centerTop +
          ', left=' +
          centerLeft
      )

      window.addEventListener('message', vm.receivedAccessToken, false)
    },

    receivedAccessToken(event) {
      this.$gfLogger.logInfo('receivedAccessToken(), event: ', event)
      var vm = this
      if (
        event.data &&
        event.data.provider &&
        event.data.provider === 'facebook' &&
        event.data.data &&
        event.data.data.hasOwnProperty('token')
      ) {
        window.removeEventListener('message', vm.receivedAccessToken)
        if (event.data.data.error != null && event.data.data.error !== '') {
          this.$emit('tokenError', event.data.data.error)
          return
        } else {
          vm.accesTokenFacebook = event.data.data.token
          vm.submitFaceBookAccount()
        }
      }
    }
  }
}
</script>

<style scoped>
.btn-login-facebook {
  border-radius: 26px;
  color: #fff;
  background-color: #3b5997;
  font-weight: bold;
}
</style>
